import type { GroupMemberRoleJSON } from 'balus-common';
import type { ParseKeys } from 'i18next';

export type GroupMemberRole = 'admin' | 'member' | 'guest';
const FallbackRole = 'member'; // 未知の値の場合には、一番弱い権限のロールにフォールバックする

const dict: Record<GroupMemberRole, string> = {
  admin: '管理者',
  member: 'メンバー',
  guest: 'ゲスト(無料)',
};

export namespace GroupMemberRole {
  export function regularValues(): GroupMemberRole[] {
    return GroupMemberRole.allValues().filter((role) => role !== 'guest');
  }

  export function allValues(): GroupMemberRole[] {
    return Object.keys(dict) as GroupMemberRole[];
  }

  export function load(value: string): GroupMemberRole {
    return GroupMemberRole.allValues().find((role) => role === value) || FallbackRole;
  }

  export function dump(role: GroupMemberRole): string {
    return role.toString();
  }

  export function isAdmin(role: string | undefined | null): boolean {
    return role === 'admin';
  }

  export function getLocalStringKey(status: GroupMemberRole): ParseKeys {
    switch (status) {
      case 'admin':
        return 'group.memberRole.admin';
      case 'member':
        return 'group.memberRole.member';
      case 'guest':
        return 'group.memberRole.guest';
    }
  }
}

export const isGroupMemberRole = (value: string): value is GroupMemberRoleJSON => {
  return value in dict;
};
